export const BNK_STMT_setNoOfStatementReducer = {
  BNK_STMT_setNoOfStatement: (state, action) => {
    state.noOfStatement = action.payload;
  },
};
